import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import AsyncCreatableReactSelect from 'react-select/async-creatable';
import usePotionSelectProps from './use-potion-select-props';
const AsyncCreatableSelect = forwardRef((props, ref) => {
    const potionSelectProps = usePotionSelectProps(props);
    return _jsx(AsyncCreatableReactSelect, Object.assign({ ref: ref }, potionSelectProps), void 0);
});
export default AsyncCreatableSelect;
